<template>
  <v-card>
    <v-img
      class="text-white border-2"
      height="60vh"
      :src="require('../../assets/images/music-wallpaper.jpg')"
      cover
    >
      <v-row class="d-flex justify-center h-100 align-center">
        <v-col cols="8"
          class="text-center text-white">
          <v-card-text>
            <p class="text-h6 my-1">
              Lorem ipsum dolor sit amet, consectetur adipisicing
              elit. Magni ut est qui harum nam modi adipisci
              soluta hic! Nam vero ipsa possimus nisi quibusdam
              vitae. Tempora iure et itaque similique?
            </p>
            <p class="text-h6 my-1">
              Lorem ipsum dolor sit amet, consectetur adipisicing
              elit. Magni ut est qui harum nam modi adipisci
              soluta hic! Nam vero ipsa possimus nisi quibusdam
              vitae. Tempora iure et itaque similique?
            </p>
          </v-card-text>

        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
